import { COMMON_BASE_URL_PREFIX } from '@flowwai-frontend/shared/constants'

export const MAPS_NO_DATA_LOCATION = {
   lat: 17.4065314,
   lng: 78.4771484
} //NOTE: Location of Hyderabad

export const MAPS_ZOOM_VALUES = {
   maxZoom: 22,
   satelliteViewMaxZoom: 20,
   minZoom: 3,
   defaultZoom: 18,
   noDataZoom: 12
}

export enum GeoLocationErrorEnum {
   Required = 'IS_REQUIRED',
   Invalid = 'IS_INVALID'
}

export const MINIMUM_EXTRUSION_HEIGHT = 20

export const FILL_EXTRUSION_LAYER_ID = 'buildings-3d'

export const EMPTY_VALUE = '-'

export const KML_FILE_UPLOADER_INPUT_ID = 'KML_FILE_UPLOADER_INPUT_ID'

export const FILE_UPLOADER_SUPPORTED_FILE_TYPES = '.kml,.kmz'

export const MAP_CONTENT_SIDE_PANE_UNIQUE_ID = 'MAP_CONTENT_SIDE_PANE_UNIQUE_ID'

export const GOOGLE_MAP_FIELDS_SIDEPANE_UNIQUE_ID =
   'GOOGLE_MAP_FIELDS_SIDEPANE_UNIQUE_ID'

export const MAP_MARKERS_SAVE_LOCATION_DISABLED_ERROR_MESSAGE_TOOLTIP_ID =
   'MAP_MARKERS_SAVE_LOCATION_DISABLED_ERROR_MESSAGE_TOOLTIP_ID'

export const ZOOM_IN_TOOLTIP_ID = 'ZOOM_IN_TOOLTIP_ID'

export const ZOOM_OUT_TOOLTIP_ID = 'ZOOM_OUT_TOOLTIP_ID'

export const CURRENT_LOCATION_TOOLTIP_ID = 'CURRENT_LOCATION'

export const GOTO_PLOT_LOCATION_TOOLTIP_ID = 'GOTO_PLOT_LOCATION'

export const HAND_TOOL_TOOLTIP_ID = 'HAND_TOOL'

export const ADD_COORDINATE_PREVIEW_KEY =
   'isMapsAddCoordinatesContextualHelpShown'

export const ADD_COORDINATE_PREVIEW_VALUE = 'YES'

export const ADD_COORDINATE_PREVIEW_GIF_URL = `${COMMON_BASE_URL_PREFIX}/gifs/add_coordinates_preview.gif`

export const ADD_COORDINATE_PREVIEW_GIF_ALT_TEXT = 'Add Coordinate Preview GIF'

export const OPEN_IN_G_MAPS_TOOL_TIP_ID = 'OPEN_IN_G_MAPS_TOOL_TIP_ID'

export enum MapsFeaturesEnum {
   OpenInGoogleEarth = 'OpenInGoogleEarth',
   OpenInGoogleMaps = 'OpenInGoogleMaps',
   CurrentLocation = 'CurrentLocation',
   CoordinatesList = 'CoordinatesList',
   PlacesSearch = 'PlacesSearch'
}

export const MARK_LOCATION_FEATURE_TOOLTIP = 'MARK_LOCATION_FEATURE_TOOLTIP'

export const SEARCHED_LOCATION_MARKER_INDEX = -1
